import { createAction, props } from '@ngrx/store';
import { Correspondence, SentCorrespondences, Templates } from './sent-correspondence.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records sent correspondences',
    props<{ id: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records sent correspondences success', 
    props<{ listData: SentCorrespondences[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records sent correspondences failure', 
    props<{ error: string }>()
);


//Fetch Templates
export const fetchTemplates = createAction(
    '[Data] fetch records sent correspondences templates',
    props<{ id: string }>()
);
export const fetchTemplatesSuccess = createAction(
    '[Data] fetch records sent correspondences templates success', 
    props<{ templates: Templates[] }>()
);
export const fetchTemplatesFail = createAction(
    '[Data] fetch records sent correspondences templates failure', 
    props<{ error: string }>()
);




// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record correspondence',
    props<{id: string, dossierId: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record correspondence success', 
    props<{ singleData: any }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record correspondence failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record correspondence',
    props<{ newData: any, dossierId: string }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record correspondence success'
);
export const addRecordFailure = createAction(
    '[Data] Add record correspondence failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state sent correspondences',
);